import script from "./CompanyPhoneCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyPhoneCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__